import React from "react"

import { useStyles } from "@/components/TopNavigation/components/RegionSelector/Dropdown/Options/Loading/Loading.styles"

const OPACITIES = [1, 0.9, 0.8, 0.7, 0.6, 0.5, 0.4, 0.3]

const Placeholder = ({ opacity }) => {
    const { classes } = useStyles({ opacity })

    return <div className={classes.placeholder} />
}

export const Loading = () => {
    const { classes } = useStyles({})

    return (
        <div className={classes.wrapper}>
            {OPACITIES.map((opacity) => (
                <Placeholder key={opacity} opacity={opacity} />
            ))}
        </div>
    )
}
